import React, { FunctionComponent, useState, useRef } from "react";
import styles from "../ListViewModal/ListViewModal.module.css";
import Modal from "react-modal";

type props = {
  open: boolean;
  close: () => void;
  title:any;
};

const ApprovalModal: FunctionComponent<props> = ({
  open,
  close,
  title
}) => {
  const areaRef: any = useRef();
  const linkRef: any = useRef();
  return (
    <Modal
      isOpen={open}
      className={styles.parent1}
      overlayClassName={styles.overlay}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      <div className={styles.headingContainer} >
        <p className={styles.profile}>{title}</p>
        </div>
      <div className={styles.buttonView}>
        <button className={styles.cancelButton} onClick={close}>
          Close
        </button>
      </div>
     </Modal>
  );
};

export default ApprovalModal;
